<template>
    <v-container :class="{'v3_index_view':  $vuetify.breakpoint.mdAndUp, 'pa-0': $vuetify.breakpoint.smAndDown}">
        <heading-view :right-column="true"></heading-view>

        <table-view></table-view>
        <role-edit-dialog></role-edit-dialog>

        <v-btn fab bottom right dark fixed color="accent" @click="showAddForm()">
            <v-icon>mdi-plus</v-icon>
        </v-btn>
    </v-container>
</template>

<script>
    import {serverBus} from '../../main';

    import TableView from '../table/TableView';
    import HeadingView from '../heading/HeadingView'
    import RoleEditDialog from "../dialogs/RoleEditDialog";

    export default {

        components: {
            TableView,
            HeadingView,
            RoleEditDialog,
        },

        created: function () {
            this.$store.commit('setTable', this.table);

            serverBus.$on('show-add-form', (item) => {
                serverBus.$emit('show-add-edit-dialog', this.table, item);
            })
        },

        methods: {
            showAddForm: function () {
                serverBus.$emit('show-add-form', {id: -1});
            },
        },

        beforeDestroy() {
            serverBus.$off('show-add-form');
        },

        data: function () {
            return {
                table: 'uloga',
            };
        }
    }
</script>